export function getIsKidsFamily(category = '') {
  const matcher = /Kids (&|&amp;) Family/g;
  return matcher.test(category);
}
